import axios from 'axios';
import apiService from '../apiService';

export default async function validateFaceDetectionFromFile(base64 = '') {
  try {
    let _request = {
      url: `${apiService.getUrl().faceRecognition}faceDetection/validateFaceDetectionFromFile`,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        base64: base64,
      }
    }
    const _ret = await axios(_request);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return _ret.data.data;
  } catch (error) {
    console.log('Error validateFaceDetectionFromFile', error);
    throw error;
  }
}
